<div style="display:none;">
	<p><strong>{{idleState}}</strong></p>
	<p *ngIf="lastPing"><small>Last keepalive ping <strong>{{lastPing}}</strong></small></p>
	<button (click)="startWatch()" *ngIf="timedOut">Restart</button>
</div>
